import FormSong from 'Components/SongComponents/FormSong'
import { DimensionInput } from 'TypeDefs/Objectives'
import { Dispatch, SetStateAction } from 'react'
import { Dimension } from 'Generated/graphql-types'
import { Header, Title, Container, Spacer, SubTitle } from './Categories.styles'
import Example from './Example'
import DimensionList from './DimensionList'
import DimensionSelector from './DimensionSelector'

type CategoriesProps = {
  allDimensions: Dimension[]
  dimensionInfo: DimensionInput[]
  setDimensionInfo: Dispatch<SetStateAction<DimensionInput[]>>
  formId: string
}

const Categories = ({
  allDimensions,
  dimensionInfo,
  setDimensionInfo,
  formId,
}: CategoriesProps) => (
  <FormSong id={formId} onSubmit={() => null}>
    <Header>
      <Title>Create data categories</Title>
      <SubTitle>
        Add more definition to your data by creating categories. For example, if
        you had after school programs in three school districts, you could add a
        category for each.
      </SubTitle>
    </Header>
    <Container>
      {dimensionInfo.length ? (
        <DimensionList
          dimensionInfo={dimensionInfo}
          setDimensionInfo={setDimensionInfo}
        />
      ) : (
        <Spacer />
      )}
      <DimensionSelector
        allDimensions={allDimensions}
        dimensionInfo={dimensionInfo}
        setDimensionInfo={setDimensionInfo}
      />
      {dimensionInfo.length === 0 && <Example />}
    </Container>
  </FormSong>
)

export default Categories
